import generated from "./telemetry.generated.json";

export const THRESHOLDS = { ACTIVE: 90, DEGRADING: 180 };

export function computeSignal(pushed, now = new Date()) {
  if (!pushed) return { pushed: null, ageDays: null, signal: null };
  const t = Date.parse(pushed + "T00:00:00Z");
  if (Number.isNaN(t)) return { pushed: null, ageDays: null, signal: null };
  const ageDays = Math.floor(
    (Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()) - t) / 86400000
  );
  const signal =
    ageDays < THRESHOLDS.ACTIVE ? "ACTIVE"
      : ageDays < THRESHOLDS.DEGRADING ? "DEGRADING"
        : "ORPHANED";
  return { pushed, ageDays, signal };
}

export function signalFor(nodeId, now = new Date()) {
  const row = (generated && generated[nodeId]) || null;
  return { ...computeSignal(row && row.pushed, now), lang: (row && row.lang) || null };
}
